import { TranslationSchema } from './ru';

/**
 * Казахский словарь строк (терминология согласована с мобильным приложением QPrice).
 */
export const kk: TranslationSchema = {
  common: {
    brandName: 'QPRICE',
    save: 'Сақтау',
    saved: 'Сақталды',
    saving: 'Сақталуда...',
    saveChanges: 'Өзгерістерді сақтау',
    cancel: 'Болдырмау',
    delete: 'Өшіру',
    edit: 'Өңдеу',
    close: 'Жабу',
    back: 'Артқа',
    next: 'Келесі',
    all: 'Барлығы',
    clear: 'Тазарту',
    retry: 'Қайталау',
    confirm: 'Растау',
    create: 'Құру',
    add: 'Қосу',
    success: 'Сәтті',
    error: 'Қате',
    notFound: 'Табылмады',
    loading: 'Жүктелуде...',
    search: 'Іздеу',
    searchPlaceholder: 'Тағамдар мен акциялар бойынша іздеу',
    themeToggle: 'Тақырыпты ауыстыру',
    themeDark: 'Күңгірт тақырып',
    themeLight: 'Ашық тақырып',
    themeSwitchToDark: 'Күңгірт тақырыпты қосу',
    themeSwitchToLight: 'Ашық тақырыпты қосу',
    support: 'Қолдау',
    supportPhone: '+7 777 246 84 83',
    supportPhoneLabel: 'Серіктестерді қолдау қызметіне қоңырау шалу',
    day: 'күн',
    daysFew: 'күн',
    daysMany: 'күн',
    today: 'бүгін',
    tomorrow: 'ертең',
    yesterday: 'кеше',
    daysAgo: 'күн бұрын',
    tenge: '₸',
  },

  landing: {
    login: 'Кіру',
    becomePartner: 'Серіктес болу',
    support: 'Қолдау',
    eyebrow: 'Клиенттері бар кез келген бизнеске арналған серіктестік платформа',
    heroTitleStrike: 'Бос сағаттарды',
    heroTitleAccent: 'клиенттерге айналдырамыз.',
    heroSub: 'QPrice — дәмханалар, сұлулық салондары, фитнес, автосервистер, дүкендер және кез келген жергілікті бизнеске арналған тікелей сату арнасы. Бос уақытқа, тауарға немесе таңғы сағатқа жеңілдік қойыңыз — 3 км радиустағы клиенттер оны қосымшадан көріп, кейін емес, дәл бүгін келеді.',
    howItWorks: 'Қалай жұмыс істейтінін көру',
    heroMeta: 'Қосылу 3 минутта · алғашқы ай тегін',

    showcaseLabel: 'Жеңілдіктеріңіздің тікелей витринасы',
    showcaseTitle: 'Бір батырма — және сіздің ұсынысыңыз жақын маңдағы клиенттің қалтасында.',
    showcaseDesc: 'Купондар мен спам-хабарламалардан айырмашылығы, QPrice дәл қазір және жақын маңда әрекет ететін ұсыныстарды ғана көрсетеді. Клиенттер «дәл қазір қайда баруға болады» деген сұраққа жауап табу үшін қосымшаны ашады.',

    statsUsers: 'қосымшаның белсенді қолданушысы',
    statsVenues: 'әр саладағы серіктес QPrice-пен жұмыс істейді',
    statsSpeed: 'тіркелуден алғашқы белсенді жеңілдікке дейін',
    statsCommission: 'чектен комиссия — тек жазылымды төлейсіз',

    cardHaircut: 'Әйелдер шаш қиюы',
    cardHaircutMeta: 'жұмыс күндері · 11:00 — 15:00',
    cardFitness: 'Жаттықтырушымен жаттығу',
    cardFitnessMeta: 'бүгінгі бос уақыт',
    cardCoffee: 'Сироп қосылған капучино',
    cardCoffeeMeta: 'happy hour · 19:00-ге дейін',

    featuresTitle: 'Неліктен серіктестер бізбен қалады',
    featuresSubtitle: 'Бұл — мекеме иесі залдың толуын нақты уақытта өзі дыбыс реттегіш сияқты басқаратын құрал.',

    feat1Title: 'Тікелей арна',
    feat1Desc: 'QPrice чектен комиссия алмайды. Барлық түсім сізде қалады — біз айналымыңыздан емес, жазылымнан табамыз.',

    feat2Title: 'Икемділік',
    feat2Desc: 'Бір сағатқа, бір қызметке, бір санатқа жеңілдік. Дәл таңдайсыз: жұма 18:00 — 20:00, тек шаш қию, тек жаңа клиенттерге.',

    feat3Title: 'Жылдамдық',
    feat3Desc: 'Жариялау — 3 секунд. Бір басу арқылы қосу және өшіру.',

    feat4Title: 'Аналитика және мәзір',
    feat4Desc: 'Әр акция бойынша қаралымдар, өтулер және қайта келулер. Мәзірді, күн тағамын, оқиғаларды бөлек қызметтерсіз жүктеңіз.',

    howTitle: 'Бұл қалай жұмыс істейді',
    howSubtitle: 'Бос уақыттан риза клиентке дейінгі үш қадам. Кассамен интеграциясыз, әзірлеушілерді қажет етпейді.',

    step1Number: '01',
    step1Title: 'Бизнесті тіркейсіз',
    step1Desc: 'Телефон нөмірі, WhatsApp-тағы код, атауы, мекенжайы және суреті. Үш минут — және профиліңіз қосымшада.',

    step2Number: '02',
    step2Title: 'Бір басумен жеңілдік жасайсыз',
    step2Desc: 'Қызметті немесе тауарды таңдайсыз, пайызды қоясыз, күндер мен сағаттарды белгілейсіз. 10 минуттан кейін алып тастағыңыз келсе — алып тастайсыз.',

    step3Number: '03',
    step3Title: 'Клиенттер келіп, толық маржа төлейді',
    step3Desc: 'Қосымша жақын маңдағы адамдарға жеңілдікті көрсетеді. Олар сізге келеді, тағы сатып алады, қайта оралады.',

    quoteText: 'Жұмыс күндері таңертең маникюрге 30% жеңілдік қойдық — және жарты жылда алғаш рет сағат 9-дан 13-ке дейінгі бос орындар толды. QPrice бізге бұрын болмаған басқару мүмкіндігін берді.',
    quoteAuthor: 'Диана М.',
    quoteRole: 'Астанадағы сұлулық салонының иесі',

    ctaTitle: 'Бір жеңілдікті сынап көріңіз. Кім келетінін көріңіз.',
    ctaSub: 'Тіркелу тегін, алғашқы ай — шектеусіз және төлемсіз. Ұнамаса — кете аласыз. Ұнаса — клиенттер ағынын жаңаша басқарыңыз.',
    ctaButton: 'Мекемені тіркеу',

    footerPartners: 'Серіктестерге арналған оферта',
    footerClients: 'Клиенттерге арналған келісім',
    footerPrivacy: 'Құпиялылық',
    footerUgc: 'Жариялау ережелері',
    footerSupport: 'Қолдау',
    footerCities: 'Алматы, Астана және тағы 12 қала',
    footerCopyright: '© 2026 QPrice.',
  },

  auth: {
    choiceEyebrow: 'Серіктес кабинеті',
    choiceTitle: 'Сіздің мекемеңіз QPrice-та',
    choiceSubtitle: 'Мәзірді, бағаларды және акцияларды өзіңіз басқарасыз — қонақтар өзгерістерді бірден көреді.',
    choiceNewVenueTitle: 'Жаңа мекеме',
    choiceNewVenueSub: 'Нөмірді растап, мекеме деректерін толтырыңыз — бұл бірнеше минут алады.',
    choiceNewVenueAction: 'Тіркелу',
    choiceExistingVenueTitle: 'Кабинетіңіз бар ма',
    choiceExistingVenueSub: 'Телефон нөмірі бойынша кіру',
    choiceLoginButton: 'Нөмір бойынша кіру',
    choiceRegisterButton: 'Мекемені тіркеу',
    choiceHintLogin: 'Кабинет бар болса — телефон нөмірі бойынша кіріңіз.',
    choiceHintRegister: 'Жаңа мекеме: нөмірді растап, мекеме деректерін толтырыңыз.',

    loginTitle: 'Серіктес кабинетіне кіру',
    loginSubtitle: 'Нөмірді енгізіңіз, біз WhatsApp арқылы код жібереміз.',
    registerTitle: 'Мекемені тіркеу',
    registerSubtitle: 'Нөмірді растап, мекеме деректерін сұраймыз — бұл бірнеше минут алады.',
    confirmTitle: 'Растау',
    enterCode: 'WhatsApp-тан кодты енгізіңіз',
    codeNoticeRegistration: 'Кодтан кейін мекеме деректерін толтыру қалады — оларсыз кабинет ашылмайды.',
    orgDetailsTitle: 'Мекеме деректері',
    orgDetailsSubtitle: 'Соңғы қадам: мекеме мәліметтерін толтырыңыз — содан кейін кабинет ашылады.',

    phoneLabel: 'Телефон нөмірі',
    phonePlaceholder: '+7 (___) ___-__-__',
    phoneButton: 'Кодты алу',
    phoneNotice: 'Растау коды WhatsApp-қа келеді',
    phoneValidationError: 'Телефон нөмірі 11 саннан тұруы керек',

    codeLabel: 'Растау коды',
    codeSentTo: 'Жіберілді:',
    codeResend: 'Кодты қайта жіберу',
    codeResendIn: 'Қайта жіберу:',
    codeConfirm: 'Растау',
    codeVerifying: 'Тексерілуде...',
    secondsShort: 'сек',

    otherDoorNoCabinet: 'Кабинетіңіз әлі жоқ па?',
    otherDoorHasCabinet: 'Кабинетіңіз бар ма?',
    otherDoorRegister: 'Тіркелу',
    otherDoorLogin: 'Кіру',

    wrongDoorCabinetNotFound: 'Бұл нөмірмен кабинет табылмады. Мекемені тіркеу керек пе?',
    wrongDoorCabinetExists: 'Бұл нөмірмен кабинет бұрыннан бар. Оған кіру керек пе?',

    legalNamePlaceholder: '«Компания» ЖШС немесе «Тегі» ЖК',
    binIin: 'БСН / ЖСН',
    city: 'Қала',
    citySelect: 'Қаланы таңдаңыз',
    legalAddressPlaceholder: 'Қала, көше, үй, кеңсе',

    venueSectionTitle: 'Мекеме',
    venueSectionHint: 'Қонақтар сізді қосымшада осылай көреді: мекеме мекенжайы бойынша бағыт сызылады.',
    venueName: 'Мекеме атауы',
    venueNamePlaceholder: 'Мысалы, «Ыңғайлы» кафесі',
    venueNameDefaultPlaceholder: 'Кофе Плюс',
    venueAddress: 'Мекеме мекенжайы',
    venueAddressPlaceholder: 'Алматы қ., Достық даңғылы 12',
    mapPickButton: 'Картадан таңдау',
    mapPickHint: 'Мекеме ғимаратын басыңыз — мекенжай өзі толтырылады. Нүктені сүйреп жылжытуға болады.',
    mapLookupLoading: 'Нүкте бойынша мекенжайды анықтап жатырмыз…',
    mapAddressHouse: 'Мекенжай нүкте бойынша қойылды — тексеріңіз.',
    mapAddressStreet: 'Нүкте бойынша тек көше табылды — үй нөмірін жазыңыз.',
    mapAddressKeptPre: 'Нүкте бойынша тек',
    mapAddressKeptPost: 'табылды — сіз енгізген мекенжай қалды.',
    mapAddressFoundPre: 'Нүкте бойынша',
    mapAddressKeptHousePost: 'табылды — сіз енгізген үй нөмірі қалды.',
    mapAddressKeptEarlierPost: 'табылды — бұрынғы мекенжай қалды, үй нөмірін тексеріңіз.',
    mapAddressNone: 'Нүкте бойынша мекенжай анықталмады — өзіңіз жазыңыз.',
    mapPointLabel: 'Нүкте',
    venueCategory: 'Негізгі санат',
    venueCategorySelect: 'Санатты таңдаңыз',
    venueCategoryOther: 'Басқа',

    consentText: 'Мен мына шарттарды қабылдаймын:',
    consentLink: 'серіктестерге арналған оферта',
    consentRequired: 'Жалғастыру үшін офертамен келісу қажет',
    offerConsentPre: 'Мен шарттарды қабылдаймын:',
    offerConsentLink: 'серіктестерге арналған жария оферта',
    offerConsentEdition: 'редакциясы:',

    submitRegistration: 'Тіркелуді аяқтау',
    submitting: 'Жөнелтілуде...',
    loginSuccess: 'Кіру сәтті орындалды',
    cabinetCreated: 'Кабинет сәтті құрылды',
    notYourNumber: 'Бұл сіздің нөміріңіз емес пе?',
    logout: 'Шығу',
    loadingReferences: 'Жүктелуде…',
    referencesError: 'Анықтамалықтарды жүктеу мүмкін болмады. Байланысты тексеріп, бетті жаңартыңыз.',
    submitFormError: 'Сауалнаманы жіберу мүмкін болмады. Қайталап көріңіз.',

    validationVenueName: 'Мекеме атауын көрсетіңіз',
    validationVenueNameShort: 'Атауы тым қысқа',
    validationCity: 'Қаланы таңдаңыз',
    validationVenueAddress: 'Мекеменің нақты мекенжайын көрсетіңіз',
    validationVenueAddressShort: 'Мекеме мекенжайы тым қысқа',
    validationCategory: 'Негізгі санатты таңдаңыз',
    validationOffer: 'Оферта талаптарын қабылдаңыз',
  },

  nav: {
    home: 'Басты бет',
    catalog: 'Мәзір',
    discounts: 'Акциялар',
    promo: 'Промо',
    qr: 'QR-кодтар',
    billing: 'Жазылым',
    accountMenu: 'Аккаунт мәзірі',
    editProfile: 'Профильді өңдеу',
    logout: 'Шығу',
    ariaTopTabs: 'Кабинет бөлімдері',
    ariaBottomNav: 'Төменгі шарлау панелі',
  },

  cabinet: {
    createDiscount: 'Акция құру',
    venueProfile: 'МЕКЕМЕ ПРОФИЛІ',
    categoryNote: 'САНАТТАР',
    categoryNoteFew: 'САНАТТАР',
    categoryNoteOne: 'САНАТ',
    discountNote: 'АКЦИЯЛАР',
    discountNoteFew: 'АКЦИЯЛАР',
    discountNoteOne: 'АКЦИЯ',
    storiesAndBanner: 'ОҚИҒАЛАР ЖӘНЕ БАННЕР',
    subscription: 'ЖАЗЫЛЫМ',

    subAccessClosed: 'ҚОЛЖЕТІМДІЛІК ЖАБЫҚ',
    subClosesToday: 'БҮГІН ЖАБЫЛАДЫ',
    subClosesTomorrow: 'ЕРТЕҢ ЖАБЫЛАДЫ',
    subClosesIn: 'ЖАБЫЛУЫНА ҚАЛДЫ:',
    subOpenBilling: 'Жазылымды ашу',

    completenessTitle: 'Мекеменің толтырылуы',
    completenessHint: 'Профиль неғұрлым толық болса, қонақтар соғұрлым жиі таңдайды',
    profileFilled: 'ТОЛТЫРЫЛДЫ',
    ariaProfileCompleteness: 'Мекеме карточкасының толтырылуы',
    whatToImprove: 'Нені жақсарту керек →',
    cardFilledPercent: 'Карточка толтырылуы:',
    fillAction: 'Толықтыру',
    requiredTag: 'МІНДЕТТІ',

    trafficTitle: 'Трафик',
    trafficPeriod: 'Кезең',
    traffic7d: '7 күн',
    traffic30d: '30 күн',
    traffic90d: '90 күн',
    metricPartnerViews: 'Карточканы қарау',
    metricPartnerViewsNote: 'мекемені ашу',
    metricCatalogOpens: 'Каталогты ашу',
    metricCatalogOpensNote: 'мәзірге кіру',
    metricDiscountOpens: 'Акцияларды ашу',
    metricDiscountOpensNote: 'қосымшадан',
    metricContactClicks: 'Байланыстар',
    metricContactClicksNote: 'қоңыраулар, желілер, бағыт',
    metricQrScans: 'QR сканерлеу',
    metricQrScansNote: 'үстел тақтайшалары',
    metricNfcTaps: 'NFC-белгілер',
    metricNfcTapsNote: 'белгіні түрту',
    deltaNoData: 'өткен кезең бойынша дерек жоқ',
    deltaToPrev: 'өткен кезеңге қатысты',
    sparklineAria: 'Күндер бойынша динамика',

    statsViews: 'Профиль қаралымдары',
    statsMenuViews: 'Мәзір қаралымдары',
    statsFavorites: 'Таңдаулыларда',
    statsActiveDiscounts: 'Белсенді акциялар',

    categoriesInCatalog: 'Каталогтағы санаттар',
    categoriesCountNote: 'витрина бөлімдері',
    activeDiscounts: 'Белсенді акциялар',
    activeDiscountsNote: 'қазір қонақтарға көрінеді',
    rating: 'Рейтинг',
    ratingNote: 'орташа баға',
    reviewsCount: 'Пікірлер',
    reviewsCountNote: 'барлық жұмыс кезеңінде',
    allDiscounts: 'Барлық акциялар',
    workNow: 'Қазір істеп тұр',
    workNowNote: 'қосымшада көрінеді',
    notWorking: 'Істемей тұр',
    notWorkingNote: 'өшірілген немесе мерзімі өткен',
    averageDiscount: 'Орташа жеңілдік',

    reviewsTitle: 'Қонақтардың пікірлері',
    noReviews: 'Әзірге пікірлер жоқ',
    reviewReportsTitle: 'Пікірлерге шағымдар',
    reviewReportsEmpty: 'Қарауда тұрған шағымдар жоқ',

    catalogTitle: 'Мәзір және тағамдар',
    addCategory: '+ Санат',
    addItem: '+ Позиция',
    createCategoryBtn: 'Санат құру',
    emptyCatalog: 'Мәзірде әзірге санаттар жоқ. Витринаны толтыру үшін алғашқысын құрыңыз.',
    emptyCatalogTitle: 'Каталог бос',
    emptyCatalogDesc: 'Алғашқы санатты құрыңыз — оған позициялар қосылып, жеңілдіктер бекітіледі.',
    nothingFound: 'Бұл сұраныс бойынша ештеңе табылмады',
    noItemsYet: 'Санаттарда әзірге позициялар жоқ',
    newCategory: 'Жаңа санат',
    categoryPlaceholder: 'Мысалы: Сусындар, Шаш қию, Көлік жуу',
    deleteCategory: 'Санатты жою',
    firstCreateCategory: 'Алдымен санат құрыңыз',
    price: 'Бағасы',
    priceWithDiscount: 'Жеңілдікпен',
    item: 'Позиция',
    category: 'Санат',
    discount: 'Жеңілдік',
    noDiscount: 'АКЦИЯСЫЗ',
    shown: 'Көрсетілді',
    outOf: 'ішінен',
    positionsCount: 'позиция',

    discountsTitle: 'Мекеме акциялары',
    emptyDiscounts: 'Сізде әзірге акциялар жоқ. Қонақтарды тарту үшін алғашқы жеңілдікті құрыңыз.',
    emptyDiscountsDesc: 'Жеңілдік — клиенттің QPrice-ты ашатын басты себебі. Алғашқысын қойыңыз: бүкіл санатқа немесе жеке позицияларға, белгілі бір күндер мен сағаттарға.',
    discountActive: 'Дәл қазір әрекет етеді',
    discountSchedule: 'Кесте бойынша',
    discountPercent: 'Жеңілдік',
    discountCol: 'Акция',
    timeCol: 'Уақыты',
    periodCol: 'Мерзімі',
    actionsCol: 'Әрекеттер',
    expired: 'Мерзімі аяқталды',
    openCatalog: 'Каталогты ашу',
    days: 'Күндер',
    allStates: 'Кез келген күйде',
    sortByTime: 'Басталу уақыты бойынша',
    sortBySize: 'Жеңілдік мөлшері бойынша',
    sortByNew: 'Алдымен жаңалары',
    reset: 'Қалпына келтіру',
    noDiscountsFiltered: 'Таңдалған сүзгілер бойынша акциялар жоқ',

    promoTitle: 'Жылжыту және оқиғалар',
    storiesTitle: 'Мекеме оқиғалары',
    addStory: 'Оқиға қосу',
    adCampaignsTitle: 'Жарнамалық науқандар',

    qrTitle: 'QR-кестелер және NFC-белгілер',
    qrSubtitle: 'Қонақтар мәзірді қосымша орнатпай ашады',
    qrDownloadPdf: 'Басып шығару үшін жүктеу',
    qrTableNumber: 'Үстел №',
    qrTargetsMenu: 'Мәзір',
    qrTargetsMenuHint: 'Үстелдегі кесте: қонақ бірден тағамдар мен бағаларды көреді',
    qrTargetsPartner: 'Мекеме карточкасы',
    qrTargetsPartnerHint: 'Кіреберістегі жапсырма, витринада, чекте',
    qrSourceQr: 'QR-код',
    qrSourceQrHint: 'Қағазға басылады, кез келген телефонда істейді',
    qrSourceNfc: 'NFC-белгі',
    qrSourceNfcHint: 'Белгіге жазылады; кейбір Android құрылғыларында NFC өшірулі — QR бәрібір қажет',
    qrModeSingle: 'Бір код',
    qrModeBatch: 'Үстелдер бойынша',
    qrTableFrom: '№ бастап',
    qrTableTo: 'дейін',
    qrShowCodes: 'Кодтарды көрсету',
    qrPrint: 'Басып шығару',
    qrDownload: 'Жүктеп алу',
    qrCopyUrl: 'Сілтемені көшіру',
    qrCopied: 'Көшірілді',
    qrCopyImage: 'Суретті көшіру',
    qrCopyImageFailed: 'Браузер суретті көшіруге рұқсат бермеді — PNG жүктеп алыңыз.',
    qrPageSub: 'Үстелдегі код сіздің мәзіріңізді ашады. Қосымшасы барлар — қосымшада, қалғандары — браузерде көреді.',
    qrNotice: 'Сканерлеулер қарапайым мәзір қарауларынан бөлек есептеледі — басты беттегі талдауда көрінеді. Егер үстелдер бойынша бассаңыз, әр үстел жеке есептеледі.',
    qrTargetLegend: 'Код қайда апарады',
    qrSourceLegend: 'Тасымалдаушы',
    qrCountLegend: 'Қанша',
    qrYourCode: 'Сіздің кодыңыз',
    qrCodesCount: 'Кодтар',
    qrPrintNotice: 'Кем дегенде 3 см өлшемде басып шығарыңыз және айналасында ақ өріс қалдырыңыз — әйтпесе камералар танымайды.',
    qrEmpty: 'Кодтар әлі құрылмаған.',
    qrHowItWorks: 'Бұл қалай жұмыс істейді',
    qrHowStep1: 'Қонақ камераны бағыттайды — сіздің бағаларыңыз бен жеңілдіктеріңіз бар мәзір ашылады.',
    qrHowStep2: 'Егер қосымша орнатылған болса, ол сілтемені қағып алып, мәзірді ішінде ашады.',
    qrHowStep3: 'Егер орнатылмаған болса — мәзір браузерде ашылып, төменде қосымшаны орнату ұсынылады.',
    qrHowStep4: 'NFC үшін сол сілтемені белгіге жазыңыз — ол осы жерден. NFC өшірілгенде белгі оқылмайды, сондықтан үстелден QR алып тастамаған жөн.',

    billingPageTitle: 'Тарифтер мен жазылым',
    currentTariff: 'Ағымдағы тариф',
    extendAction: 'Жазылымды ұзарту',
    noPaymentNeeded: 'Төлем әзірге қажет емес',
    noPaymentNeededDesc: 'Алдымен мекемені іске қосыңыз — басты беттегі түйме. Сынақ мерзімі іске қосылған сәттен басталады.',
    toMain: 'Басты бетке',

    legalTitle: 'Деректемелер',
    legalHint: 'Міндетті емес. Шарт немесе жабу құжаттары қажет болғанда толтырыңыз — кез келген өрісті, кез келген уақытта.',
    legalPrivacyNote: 'Деректемелерді тек QPrice көреді — қосымша қонақтарына көрсетілмейді.',
    legalForm: 'Меншік нысаны',
    legalFormNone: 'Таңдалмаған',
    legalName: 'Толық атауы',
    legalNamePlaceholder: '«Кофе Плюс» ЖШС',
    legalNumberHint: 'Тіркеу туралы куәліктен 12 сан',
    legalNumberPlaceholder: '12 сан',
    legalAddress: 'Заңды мекенжай',
    legalAddressHint: 'Тіркеу құжаттарындағы мекенжай, мекеме мекенжайы емес.',
    legalAddressPlaceholder: 'Алматы қ., Абай к-сі 1, 5 кеңсе',
    legalNameShort: 'Атауы тым қысқа',
    legalAddressShort: 'Заңды мекенжай тым қысқа',
    legalSave: 'Деректемелерді сақтау',
    legalSaving: 'Сақталуда…',
    legalSaved: 'Деректемелер сақталды',
    legalSaveError: 'Деректемелерді сақтау мүмкін болмады. Қайталап көріңіз.',
    legalEmpty: 'Толтырылмаған. Бұл міндетті емес — шарт пен жабу құжаттары үшін қажет болады.',
    legalFill: 'Толтыру',
    legalEdit: 'Өзгерту',
    legalOfferAccepted: 'Оферта қабылданды',
    legalOfferEdition: 'редакциясы',
  },

  discounts: {
    eyebrow: 'Акциялар',
    eyebrowCategory: 'санат толығымен',
    eyebrowItems: '{count} поз.',
    eyebrowPieces: '{count} дана',
    eyebrowNothing: 'таңдалмаған',
    titleNew: 'Жаңа жеңілдік',
    titleEdit: 'Жеңілдікті өңдеу',
    dirty: 'Сақталмаған өзгерістер бар',
    clean: 'Барлығы сақталды',
    cancel: 'Болдырмау',
    create: 'Жеңілдік құру',
    save: 'Сақтау',
    saving: 'Сақталуда…',
    created: 'Жеңілдік құрылды',
    updated: 'Жеңілдік жаңартылды',
    saveFailed: 'Жеңілдікті сақтау мүмкін болмады',
    footNow: 'Жеңілдік сақталған бойда қосылады және тек таңдалған уақытта әрекет етеді.',
    footLater: 'Жеңілдік қосымшада {date} пайда болады және тек таңдалған уақытта әрекет етеді.',

    cardMain: 'Жеңілдік',
    cardMainHint: 'Атауын қонақ қосымшада көреді. Баға жеңілдік түріне қарай есептеледі.',
    name: 'Атауы',
    namePlaceholder: 'Мысалы: Шай мен пирожное 18:00-ге дейін',
    nameHint: 'Міндетті емес. Атауы болмаса, жеңілдік неге қолданылатынымен аталады.',
    kind: 'Жеңілдік түрі',
    kindGroup: 'Позицияларға',
    kindGroupHint: 'Санаттың немесе тізімнің әр позициясынан пайыз не теңге.',
    kindCombo: 'Комбо',
    kindComboHint: 'Бірнеше позиция бір бағамен: шай мен пирожное 1 500 ₸.',

    cardTarget: 'Неге қолданылады',
    cardTargetHint: 'Мәзір санаты толығымен немесе жеке позициялар.',
    target: 'Жеңілдік нысаны',
    targetCategory: 'Санат толығымен',
    targetItems: 'Жеке позициялар',
    targetCategoryHint: 'Санатты таңдаңыз. Ішкі санаттары болса, жеңілдік оларға да қолданылады.',
    targetItemsHint: 'Санатты ашып, позицияларды белгілеңіз.',
    targetPickedCategory: '«{name}» санаты толығымен · позициялар: {count}',
    targetPickedItems: 'Белгіленген позициялар: {count}',
    errorTargetCategory: 'Санатты таңдаңыз',
    errorTargetItems: 'Кемінде бір позицияны белгілеңіз',

    cardValue: 'Жеңілдік мөлшері',
    cardValueHint: 'Әр позицияның бағасынан шегеріледі: пайызбен немесе теңгемен.',
    value: 'Мөлшері',
    valueUnit: 'Пайыз немесе теңге',
    valuePercentHint: 'Әдеттегі бағаның 1–100 %.',
    valueAmountHint: 'Әр позициядан бүтін теңге.',
    valueAmountHintMax: 'Ең арзан позицияның бағасынан аспауы керек: {price}.',
    errorPercent: 'Пайыздық жеңілдік — 1-ден 100-ге дейінгі бүтін сан',
    errorAmount: 'Жеңілдік сомасын көрсетіңіз — кемінде 1 теңге, бүтін сан',
    errorAmountTooBig:
      '{amount} жеңілдік «{name}» бағасынан ({price}) көп. Жеңілдікті азайтыңыз немесе пайызбен көрсетіңіз.',
    errorAmountNoItems: 'Санатта позициялар жоқ — теңгемен жеңілдік қолданылмайды. Пайызбен көрсетіңіз.',
    preview: 'Бұрын → жеңілдікпен',
    previewCheapest: 'Ең арзаны',
    previewPriciest: 'Ең қымбаты',
    previewSingle: 'Позиция',
    previewEmpty: 'Жеңілдік неге қолданылатынын таңдаңыз — мұнда бағалар көрінеді.',

    cardCombo: 'Комбо құрамы',
    cardComboHint: 'Позицияларды белгілеп, санын көрсетіңіз. Қонақ жиынтықты толық алады.',
    comboEmpty: 'Әзірге бос — төмендегі мәзірден позицияларды белгілеңіз.',
    comboPick: 'Мәзір позициялары',
    comboQuantity: 'Саны: {name}',
    comboLess: 'Азайту: {name}',
    comboMore: 'Көбейту: {name}',
    comboRemove: 'Комбодан алып тастау: {name}',
    comboUnitPrice: '{price} / дана',
    comboHidden: 'Сатылымда жоқ — позиция жасырулы тұрғанда қонақ комбоны көрмейді',
    comboRegular: 'Жиынтықтың әдеттегі бағасы',
    errorCombo: 'Комбода кемінде екі дана болуы керек: екі позиция немесе бір позиция екі рет',

    cardBundle: 'Комбо бағасы',
    cardBundleHint: 'Қонақ бүкіл жиынтыққа төлейтін баға. Ол әдеттегі бағадан төмен болуы керек.',
    bundle: 'Комбо бағасы, ₸',
    bundleHint: 'Бүкіл жиынтыққа бүтін теңге.',
    bundleRegular: 'Әдеттегі баға',
    bundlePrice: 'Комбо бағасы',
    bundleSaving: 'Қонақ үнемдейді',
    bundleNoSaving: 'үнем жоқ',
    errorBundle: 'Комбо бағасын көрсетіңіз — бүтін теңге',
    errorBundleTooHigh: 'Комбо бағасы жиынтықтың әдеттегі бағасынан төмен болуы керек: {price}',

    cardWhen: 'Қашан әрекет етеді',
    cardWhenHint: 'Тәулік ішіндегі уақыт және апта күндері. Күн уақыттың басталуы бойынша саналады.',
    timeFrom: 'Басталуы',
    timeTo: 'Аяқталуы',
    timeOvernight: 'Уақыт түн ортасынан өтеді: келесі күні {time} аяқталады.',
    errorTime: 'Басталу және аяқталу уақытын көрсетіңіз',
    errorTimeSame: 'Басталуы мен аяқталуы бірдей болмауы керек',
    days: 'Апта күндері',
    daysWeekdays: 'Жұмыс күндері',
    daysWeekend: 'Демалыс күндері',
    daysAll: 'Барлық күн',
    daysClear: 'Тазарту',
    errorDays: 'Кемінде бір апта күнін таңдаңыз',
    dayMon: 'Дс',
    dayTue: 'Сс',
    dayWed: 'Ср',
    dayThu: 'Бс',
    dayFri: 'Жм',
    daySat: 'Сб',
    daySun: 'Жс',

    cardPeriod: 'Акция мерзімі',
    cardPeriodHint: 'Күнтізбелік күндер; тәулік ішіндегі уақыт жоғарыда көрсетіледі.',
    startsAt: 'Басталу күні',
    startsAtHint: 'Бос болса — акция қазір жүріп тұр.',
    endsAt: 'Аяқталу күні',
    endsAtHint: 'Осы күнді қоса алғанда. Бос болса — мерзімсіз.',
    errorEndsAt: 'Аяқталу күні басталу күнінен ерте болмауы керек',

    menuLoading: 'Мәзір жүктелуде…',
    menuError: 'Мәзірді жүктеу мүмкін болмады',
    menuRetry: 'Қайталау',
    menuEmpty: 'Мәзірде әзірге санаттар жоқ. Санат құрып, оған позициялар қосыңыз.',
    treeBranch: 'ішкі санаттары бар',
    treeCount: '{count} поз.',
    treeChecked: 'белгіленді: {count}',
    treeEmpty: 'Бұл санатта әзірге позициялар жоқ',
    treeSelectAll: 'Барлығын таңдау',
    treeUnselectAll: 'Белгілерді алу',
    treeExpand: 'Санатты ашу',
    treeCollapse: 'Санатты жабу',

    filterKind: 'Акция түрі',
    filterKindAll: 'Барлық түрлері',
    filterKindGroup: 'Позицияларға',
    filterKindCombo: 'Комбо',
    badgeCombo: 'Комбо',
    scopeCategory: '«{name}» санаты',
    scopeCategoryUnnamed: 'Санат',
    scopeNoItems: 'Позициялар таңдалмаған',
    scopeItemOne: 'позиция',
    scopeItemFew: 'позиция',
    scopeItemMany: 'позиция',
    subtitleCategory: 'Санатқа жеңілдік',
    subtitleItems: 'Позицияларға жеңілдік',
    subtitleCombo: 'Комбо жиынтық',
    comboInstead: '{price} орнына',
    comboNoSaving: 'үнем жоқ',
    comboNoSavingTitle:
      'Комбо бағасы позициялардың қазіргі сомасынан төмен емес — қонақ бұл комбоны көрмейді',
    kpiKinds: '{group} позицияларға · {combo} комбо',
    kpiAverageNote: 'ең көбі −{max} % · тек пайыздық жеңілдіктер',
    kpiAverageNone: 'пайыздық жеңілдіктер жоқ',
  },
};
